import { render, staticRenderFns } from "./BookingPeriodList.vue?vue&type=template&id=85ad5a18&"
import script from "./BookingPeriodList.vue?vue&type=script&lang=js&"
export * from "./BookingPeriodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports